import { combineReducers } from 'redux';
import estimates from './estimatesReducer';
import containers from './containersReducer';
import items from './itemsReducer';
import uiStateReducer from './uiStateReducer';
import mandiAvailabilityReducer from './mandiAvailabilityReducer';
import copyStylesReducer from './copyStylesReducer';
import renameWindowLabelReducer from './renameWindowLabelReducer';
import shareReducer from './shareReducer';
import designsSummaryReducer from './designsSummaryReducer';
import originReducer from './originModeReducer';
import mandiReducer from './installationPricingReducer';
import thdStoreInfoReducer from './thdStoreInfoReducer';

export const entitiesReducer = combineReducers({
  estimates,
  containers,
  items,
});

const estimateBuilderReducer = combineReducers({
  entities: entitiesReducer,
  uiState: uiStateReducer,
  mandiAvailability: mandiAvailabilityReducer,
  copyStyles: copyStylesReducer,
  share: shareReducer,
  designsSummary: designsSummaryReducer,
  mandi: mandiReducer,
  windowLabel: renameWindowLabelReducer,
  thdStoreInfo: thdStoreInfoReducer,
});

const rootReducer = combineReducers({
  estimateBuilder: estimateBuilderReducer,
  originReducer,
});

export default rootReducer;
